// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'audit.auditoriaPage.noRecord': 'sem registro',
    'audit.auditoriaPage.exportSuccess': 'Exportação concluída. O acesso foi registrado na própria trilha.',
    'audit.auditoriaPage.when': 'Data / Horário',
    'audit.auditoriaPage.action': 'Ação',
    'audit.auditoriaPage.result': 'Resultado',
    'audit.auditoriaPage.result.success': 'Sucesso',
    'audit.auditoriaPage.result.denied': 'Negado',
    'audit.auditoriaPage.result.error': 'Erro',
    'audit.auditoriaPage.who': 'Usuário',
    'audit.auditoriaPage.unauthenticated': 'não autenticado',
    'audit.auditoriaPage.record': 'Registro',
    'audit.auditoriaPage.origin': 'Origem',
    'audit.auditoriaPage.origin.interface': 'Interface',
    'audit.auditoriaPage.origin.api': 'API',
    'audit.auditoriaPage.origin.import': 'Importação',
    'audit.auditoriaPage.origin.system': 'Processo interno',
    'audit.auditoriaPage.title': 'Auditoria',
    'audit.auditoriaPage.eyebrow': 'Segurança',
    'audit.auditoriaPage.subtitle': 'Trilha somente leitura. Cada consulta e exportação também é registrada.',
    'audit.auditoriaPage.clearFilters': 'Limpar filtros',
    'audit.auditoriaPage.exportCsv': 'Exportar CSV',
    'audit.auditoriaPage.from': 'De',
    'audit.auditoriaPage.to': 'Até',
    'audit.auditoriaPage.recordType': 'Tipo de registro',
    'audit.auditoriaPage.user': 'Usuário',
    'audit.auditoriaPage.userPlaceholder': 'e-mail ou parte dele',
    'audit.auditoriaPage.requestId': 'Identificador da requisição',
    'audit.auditoriaPage.empty': 'Nenhum evento para os filtros informados.',
    'audit.auditoriaPage.eventDetail': 'Detalhe do evento',
    'audit.auditoriaPage.reason': 'Motivo',
    'audit.auditoriaPage.role': 'Papel',
    'audit.auditoriaPage.userPairsAtTime': 'Duplas do usuário na época',
    'audit.auditoriaPage.recordId': 'Identificador do registro',
    'audit.auditoriaPage.changedFields': 'Campos alterados',
    'audit.auditoriaPage.before': 'Antes',
    'audit.auditoriaPage.after': 'Depois',
    'audit.auditoriaPage.sensitiveDataNotice': 'Senha, token, cookie, segredo de segundo fator e código de recuperação nunca são gravados. Campo não declarado aparece apenas pelo nome.',
  },
  en: {
    'audit.auditoriaPage.noRecord': 'no record',
    'audit.auditoriaPage.exportSuccess': 'Export complete. Access was recorded in the audit trail.',
    'audit.auditoriaPage.when': 'Date / Time',
    'audit.auditoriaPage.action': 'Action',
    'audit.auditoriaPage.result': 'Result',
    'audit.auditoriaPage.result.success': 'Success',
    'audit.auditoriaPage.result.denied': 'Denied',
    'audit.auditoriaPage.result.error': 'Error',
    'audit.auditoriaPage.who': 'User',
    'audit.auditoriaPage.unauthenticated': 'unauthenticated',
    'audit.auditoriaPage.record': 'Record',
    'audit.auditoriaPage.origin': 'Origin',
    'audit.auditoriaPage.origin.interface': 'Interface',
    'audit.auditoriaPage.origin.api': 'API',
    'audit.auditoriaPage.origin.import': 'Import',
    'audit.auditoriaPage.origin.system': 'Internal process',
    'audit.auditoriaPage.title': 'Audit',
    'audit.auditoriaPage.eyebrow': 'Security',
    'audit.auditoriaPage.subtitle': 'Read-only trail. Every query and export is also recorded.',
    'audit.auditoriaPage.clearFilters': 'Clear filters',
    'audit.auditoriaPage.exportCsv': 'Export CSV',
    'audit.auditoriaPage.from': 'From',
    'audit.auditoriaPage.to': 'To',
    'audit.auditoriaPage.recordType': 'Record type',
    'audit.auditoriaPage.user': 'User',
    'audit.auditoriaPage.userPlaceholder': 'email or part of it',
    'audit.auditoriaPage.requestId': 'Request identifier',
    'audit.auditoriaPage.empty': 'No events match the selected filters.',
    'audit.auditoriaPage.eventDetail': 'Event details',
    'audit.auditoriaPage.reason': 'Reason',
    'audit.auditoriaPage.role': 'Role',
    'audit.auditoriaPage.userPairsAtTime': 'User pairs at the time',
    'audit.auditoriaPage.recordId': 'Record identifier',
    'audit.auditoriaPage.changedFields': 'Changed fields',
    'audit.auditoriaPage.before': 'Before',
    'audit.auditoriaPage.after': 'After',
    'audit.auditoriaPage.sensitiveDataNotice': 'Passwords, tokens, cookies, two-factor secrets, and recovery codes are never recorded. Undeclared fields appear only by name.',
  },
  es: {
    'audit.auditoriaPage.noRecord': 'sin registro',
    'audit.auditoriaPage.exportSuccess': 'Exportación completada. El acceso quedó registrado en la propia auditoría.',
    'audit.auditoriaPage.when': 'Fecha / Hora',
    'audit.auditoriaPage.action': 'Acción',
    'audit.auditoriaPage.result': 'Resultado',
    'audit.auditoriaPage.result.success': 'Éxito',
    'audit.auditoriaPage.result.denied': 'Denegado',
    'audit.auditoriaPage.result.error': 'Error',
    'audit.auditoriaPage.who': 'Usuario',
    'audit.auditoriaPage.unauthenticated': 'no autenticado',
    'audit.auditoriaPage.record': 'Registro',
    'audit.auditoriaPage.origin': 'Origen',
    'audit.auditoriaPage.origin.interface': 'Interfaz',
    'audit.auditoriaPage.origin.api': 'API',
    'audit.auditoriaPage.origin.import': 'Importación',
    'audit.auditoriaPage.origin.system': 'Proceso interno',
    'audit.auditoriaPage.title': 'Auditoría',
    'audit.auditoriaPage.eyebrow': 'Seguridad',
    'audit.auditoriaPage.subtitle': 'Registro de solo lectura. Cada consulta y exportación también queda registrada.',
    'audit.auditoriaPage.clearFilters': 'Limpiar filtros',
    'audit.auditoriaPage.exportCsv': 'Exportar CSV',
    'audit.auditoriaPage.from': 'Desde',
    'audit.auditoriaPage.to': 'Hasta',
    'audit.auditoriaPage.recordType': 'Tipo de registro',
    'audit.auditoriaPage.user': 'Usuario',
    'audit.auditoriaPage.userPlaceholder': 'correo electrónico o parte de él',
    'audit.auditoriaPage.requestId': 'Identificador de la solicitud',
    'audit.auditoriaPage.empty': 'Ningún evento coincide con los filtros seleccionados.',
    'audit.auditoriaPage.eventDetail': 'Detalle del evento',
    'audit.auditoriaPage.reason': 'Motivo',
    'audit.auditoriaPage.role': 'Rol',
    'audit.auditoriaPage.userPairsAtTime': 'Parejas del usuario en ese momento',
    'audit.auditoriaPage.recordId': 'Identificador del registro',
    'audit.auditoriaPage.changedFields': 'Campos modificados',
    'audit.auditoriaPage.before': 'Antes',
    'audit.auditoriaPage.after': 'Después',
    'audit.auditoriaPage.sensitiveDataNotice': 'Las contraseñas, tokens, cookies, secretos de segundo factor y códigos de recuperación nunca se registran. Los campos no declarados aparecen solo por su nombre.',
  },
}
